import { LAYOUTS, DB_DATA_FIELDS, LOCATION_FIELDS } from "./dbConstants";

const PANEL_WIDTH_LARGE = 6;
const PANEL_HEIGHT_LARGE = 8.5;
const PANEL_WIDTH_SMALL = 12;
const PANEL_HEIGHT_SMALL = 8.5;

const imuLayouts = {
  lg: [
    { i: 'panel1', x: 0, y: 0, w: 4, h: 8.5 },
    { i: 'panel2', x: 4, y: 0, w: 4, h: 8.5 },
    { i: 'panel3', x: 8, y: 0, w: 4, h: 8.5 },
    { i: 'panel4', x: 0, y: 1, w: 4, h: 8.5 },
    { i: 'panel5', x: 4, y: 1, w: 4, h: 8.5 },
    { i: 'panel6', x: 8, y: 1, w: 4, h: 8.5 },
    { i: 'panel7', x: 0, y: 2, w: 12, h: 8.5 },
  ],
  md: [
    { i: 'panel1', x: 0, y: 0, w: 4, h: 8.5 },
    { i: 'panel2', x: 4, y: 0, w: 4, h: 8.5 },
    { i: 'panel3', x: 8, y: 0, w: 4, h: 8.5 },
    { i: 'panel4', x: 0, y: 1, w: 4, h: 8.5 },
    { i: 'panel5', x: 4, y: 1, w: 4, h: 8.5 },
    { i: 'panel6', x: 8, y: 1, w: 4, h: 8.5 },
    { i: 'panel7', x: 0, y: 2, w: 12, h: 8.5 },
  ],
  sm: [
    { i: 'panel1', x: 0, y: 0, w: 12, h: 10, moved:false, static: true },
    { i: 'panel2', x: 0, y: 0, w: 12, h: 10, moved:false, static: true },
    { i: 'panel3', x: 0, y: 1, w: 12, h: 10, moved:false, static: true },
    { i: 'panel4', x: 0, y: 1, w: 12, h: 10, moved:false, static: true },
    { i: 'panel5', x: 0, y: 2, w: 12, h: 10, moved:false, static: true },
    { i: 'panel6', x: 0, y: 2, w: 12, h: 10, moved:false, static: true },
    { i: 'panel7', x: 0, y: 3, w: 12, h: 10, moved:false, static: true },
    { i: 'panel8', x: 0, y: 3, w: 12, h: 10, moved:false, static: true },
  ]
}

const locationLayouts = {
  lg: [
    { i: 'panel1', x: 0, y: 0, w: 6, h: 16 },
    { i: 'panel2', x: 6, y: 0, w: 6, h: 8.5 },
    { i: 'panel3', x: 6, y: 1, w: 6, h: 8.5 },
  ],
  md: [
    { i: 'panel1', x: 0, y: 0, w: 6, h: 16 },
    { i: 'panel2', x: 6, y: 0, w: 6, h: 8 },
    { i: 'panel3', x: 6, y: 1, w: 6, h: 8 },
  ],
  sm: [
    { i: 'panel1', x: 0, y: 0, w: 12, h: 16 },
    { i: 'panel2', x: 0, y: 1, w: 12, h: 8 },
    { i: 'panel3', x: 0, y: 2, w: 12, h: 8 },
  ]
};

export const getFieldsList = (layoutType) => {
  const locationFields = LOCATION_FIELDS.children
  const imuFields = DB_DATA_FIELDS.IMU.children
  const telemetryFields = DB_DATA_FIELDS.TELEMETRY.children
  const motorFields = DB_DATA_FIELDS.MOTOR.children
  const batteryFields = DB_DATA_FIELDS.BATTERY.children


  let layoutFields=[];
  switch (layoutType){
    case LAYOUTS.LOCATION: layoutFields = locationFields; break;
    case LAYOUTS.IMU: layoutFields = imuFields; break;
    case LAYOUTS.TELEMETRY: layoutFields = telemetryFields; break;
    case LAYOUTS.MOTOR: layoutFields = motorFields; break;
    case LAYOUTS.BATTERY: layoutFields = batteryFields; break;
    case LAYOUTS.BATTERYCELL: layoutFields = telemetryFields; break;
    default: layoutFields = telemetryFields; break;
  }
  return(layoutFields);
}

export const generateLayout = (layoutType) => {
  if (layoutType === LAYOUTS.LOCATION) {
    return (locationLayouts);
  } else if (layoutType === LAYOUTS.IMU) {
    return (imuLayouts);
  } else {
    const layoutFields = getFieldsList(layoutType);
    //lg layout and md layout is the same
    let lg = []
    let row = 0;
    layoutFields.forEach((_, index) => {
      let newPanel = {};
      newPanel.i = `panel${index+1}`;
      newPanel.x = index % 2 === 0 ? 0 : PANEL_WIDTH_LARGE; 
      newPanel.y = row;
      row = index % 2 === 0 ? row : row+1;
      newPanel.w = PANEL_WIDTH_LARGE;
      newPanel.h = PANEL_HEIGHT_LARGE;
      newPanel.moved = false;
      newPanel.static = false;
      lg.push(newPanel);
    })
    // sm, layout
    let sm = [];
    row = 0;
    layoutFields.forEach((_, index) => {
      let newPanel = {};
      newPanel.i = `panel${index+1}`
      newPanel.x = 0; 
      newPanel.y = row++;
      newPanel.w = PANEL_WIDTH_SMALL;
      newPanel.h = PANEL_HEIGHT_SMALL;
      newPanel.moved = false;
      newPanel.static = false;
      sm.push(newPanel);
    })
    return ({
      lg,
      md: lg,
      sm,
    })
  }
}

export const exportToCSV = (data, filename='export.csv') => {
  if (!data || data.length === 0) return;

  const headers = Object.keys(data[0]);
  const csvRows = [
    headers.join(','),
    ...data.map(row =>
      headers.map(field => {
        const cell = row[field];
        if (typeof cell === 'string' && cell.includes(',')) {
          return `"${cell}"`;
        }
        return cell;
      }).join(',')
    ),
  ];

  const csvContent = csvRows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};